import React from 'react';

import { Inline } from '@99designs/ui';
import { IconInfo, IconError, IconCaution, IconSuccess } from '@99designs/icons';
import { colors, typography } from '@99designs/ui/settings';
import styled from 'styled-components';

export type StatusMessageType = 'caution' | 'error' | 'info' | 'success';

export interface Props {
    children: React.ReactNode;
    type: StatusMessageType;
}

type SemanticStatusMessageProps = Pick<Props, 'children'>;

const StyledStatusMessage = styled.div`
    font-weight: ${typography.fontWeights.medium};
`;

const CautionStatusMessage = ({ children }: SemanticStatusMessageProps) => (
    <StyledStatusMessage
        css={`
            color: ${colors.semantic.caution};
        `}
    >
        <Inline space={'quarterGutter'}>
            <IconCaution />
            <div>{children}</div>
        </Inline>
    </StyledStatusMessage>
);

const ErrorStatusMessage = ({ children }: SemanticStatusMessageProps) => (
    <StyledStatusMessage
        css={`
            color: ${colors.semantic.error};
        `}
    >
        <Inline space={'quarterGutter'}>
            <IconError />
            <div>{children}</div>
        </Inline>
    </StyledStatusMessage>
);

const InfoStatusMessage = ({ children }: SemanticStatusMessageProps) => (
    <StyledStatusMessage
        css={`
            color: ${colors.semantic.info};
        `}
    >
        <Inline space={'quarterGutter'}>
            <IconInfo />
            <div>{children}</div>
        </Inline>
    </StyledStatusMessage>
);

const SuccessStatusMessage = ({ children }: SemanticStatusMessageProps) => (
    <StyledStatusMessage
        css={`
            color: ${colors.semantic.success};
        `}
    >
        <Inline space={'quarterGutter'}>
            <IconSuccess />
            <div>{children}</div>
        </Inline>
    </StyledStatusMessage>
);

export default function StatusMessage({ children, type }: Props) {
    let StatusMessageComponent;

    switch (type) {
        case 'caution':
            StatusMessageComponent = CautionStatusMessage;
            break;
        case 'error':
            StatusMessageComponent = ErrorStatusMessage;
            break;
        case 'info':
            StatusMessageComponent = InfoStatusMessage;
            break;
        case 'success':
            StatusMessageComponent = SuccessStatusMessage;
            break;
        default:
            StatusMessageComponent = InfoStatusMessage;
    }
    return <StatusMessageComponent>{children}</StatusMessageComponent>;
}
